var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMoloLogoBlackWs = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1054.07 597.35",
    style: {
      enableBackground: "new 0 0 1054.07 597.35"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "392.53,410.71 381.06,279.58 341.01,415.22 309.93,417.94 245.41,291.73 256.86,422.58 219.11,425.88  201.76,227.53 249.57,223.34 321.33,362.36 365.26,213.22 413.12,209.03 430.48,407.39  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.62,
    y: 189.34,
    transform: "matrix(0.9962 -0.0872 0.0872 0.9962 -22.7333 57.1069)",
    className: "st0",
    width: 38,
    height: 199.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M562.21,322.41c-2.45-28.03-21.48-40.91-41.46-39.16c-19.71,1.72-36.48,17.73-34.03,45.77 c2.45,28.03,21.8,41.44,41.51,39.72C548.21,366.98,564.69,350.72,562.21,322.41 M600.08,319.07c3.92,44.83-25.21,80.2-68.84,84.02 c-43.34,3.79-78.16-25.99-82.09-70.82c-3.9-44.53,25.23-79.9,68.57-83.69C561.35,244.76,596.18,274.54,600.08,319.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M802.51,301.38c-2.45-28.03-21.48-40.91-41.46-39.16c-19.71,1.72-36.48,17.73-34.03,45.77 c2.45,28.03,21.8,41.44,41.51,39.72C788.52,345.96,804.99,329.69,802.51,301.38 M840.38,298.05c3.92,44.83-25.21,80.2-68.84,84.02 c-43.34,3.79-78.16-25.99-82.09-70.82c-3.9-44.53,25.23-79.9,68.57-83.69C801.65,223.74,836.48,253.52,840.38,298.05"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoloLogoBlackWs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Molo_Logo_Black_WS.6a092b58.svg";
export { ForwardRef as ReactComponent };